import moment from "moment";

export const MidnightMoment = moment().startOf("day");
export const MidnightTimeFormat = "12:00 AM";
